import ComicCard from '@/components/feature/ComicCard';
import { getLatestUpdates } from '@/mocks/comics';
import { Link } from 'react-router-dom';

export default function LatestUpdatesSection() {
  const latest = getLatestUpdates(8);

  return (
    <section className="py-14 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              每日更新，精彩不停——<strong>韩漫网站</strong>持续追踪最热<strong>漫画韩漫</strong>
            </p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer transition-colors"
          >
            更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {latest.map((comic) => (
            <div key={comic.id}>
              <ComicCard comic={comic} />
              <p className="mt-1.5 px-1 text-xs text-foreground-400">
                更新至 {comic.chapters[0]?.title || comic.chapters[0]?.number + '话'}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer"
          >
            更多漫画 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}